import type { Resource } from "../../types/Resource";

export const unassignedShiftsResource: Partial<Resource> = {
    id: "unassigned-shifts",
};
